import { auth, notConnected } from './metas'
const Setup = () => import('@/pages/Setup')
const Login = () => import('@/pages/Login')
const Logout = () => import('@/pages/Logout')
const ResetPassword = () => import('@/pages/ResetPassword')
const Invitation = () => import('@/pages/Invitation')
const ForgotPassword = () => import('@/pages/ForgotPassword')
const Account = () => import('@/pages/Account')

export default [
  {
    path: '/setup',
    name: 'Setup',
    component: Setup,
    meta: auth
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: notConnected
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: auth
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: notConnected
  },
  {
    path: '/reset_password/:platformName/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    props: true,
    meta: notConnected
  },
  {
    path: '/invitations/:platformToken/:token',
    name: 'Invitation',
    component: Invitation,
    props: true,
    meta: notConnected
  },
  {
    path: '/account/:tab',
    name: 'Account',
    component: Account,
    meta: auth,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/session.route.js